export interface KeywordMapping {
    keyword_mapping_id: number
    service_id: number
    keyword: string
    keyword_normalized: string
    search_intent: string
    h1_text: string
    active: boolean
    modified_by: number | null
    created: string
    modified: string
    serviceName: string
    countryCode: string
    modifiedByName: string | null
}

export interface KeywordMappingSave {
    keyword_mapping_id: number | string
    service_id: number
    keyword: string
    search_intent: string
    h1_text: string
    active: boolean
}

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null
}

function readString(value: unknown): string {
    if (typeof value === 'string') return value
    return ''
}

function readNullableString(value: unknown): string | null {
    if (typeof value === 'string') return value
    return null
}

export function readKeywordMapping(value: unknown): KeywordMapping | null {
    if (!isRecord(value)) return null
    if (typeof value.keyword_mapping_id !== 'number') return null
    if (typeof value.service_id !== 'number') return null
    if (typeof value.keyword !== 'string') return null
    if (typeof value.search_intent !== 'string') return null
    if (typeof value.h1_text !== 'string') return null
    if (value.active !== true && value.active !== false) return null

    return {
        keyword_mapping_id: value.keyword_mapping_id,
        service_id: value.service_id,
        keyword: value.keyword,
        keyword_normalized: readString(value.keyword_normalized),
        search_intent: value.search_intent,
        h1_text: value.h1_text,
        active: value.active,
        modified_by: typeof value.modified_by === 'number' ? value.modified_by : null,
        created: readString(value.created),
        modified: readString(value.modified),
        serviceName: readString(value.serviceName),
        countryCode: readString(value.countryCode),
        modifiedByName: readNullableString(value.modifiedByName),
    }
}
